





























































import { Dialog } from 'element-ui'
import html2pdf from 'html2pdf.js'
import { Component, Vue, Prop } from 'vue-property-decorator'

import ModalSteps from '@/components/modals/ModalSteps.vue'
import PassengersPaymentTab from '@/components/modals/PassengersPaymentTab.vue'
import MedexperienceBody from '@/components/modals/VisaLetterModal/MedexperienceBody.vue'
import SailCroatiaBody from '@/components/modals/VisaLetterModal/SailCroatiaBody.vue'

import Booking from '@/models/booking'
import Customer from '@/models/customer'
import Passenger from '@/models/passenger'
import Recipient from '@/models/recipient'
import { VisaLetterData } from '@/models/visa-letter-data'
import VisaLetterModalSteps from '@/models/visa-letter-modal-steps'

import { VisaLetterModalMutationTypes } from '@/store/modules/visaLetterModal'

@Component({
  components: {
    [Dialog.name]: Dialog,
    PassengersTab: PassengersPaymentTab,
    ModalSteps,
    SailCroatiaBody,
    MedexperienceBody,
  },
})
export default class VisaLetterModal extends Vue {
  @Prop() booking!: Booking
  @Prop() passengers!: Passenger[]
  @Prop() currentCustomer!: Customer
  @Prop() visaLetterData!: VisaLetterData

  initialSetupDone = false

  get visible(): boolean {
    return this.$store.state.visaLetterModal.visible
  }

  get recipients(): { [id: number]: Recipient } {
    return this.$store.getters.visaLetterRecipients
  }

  get currentStep(): VisaLetterModalSteps {
    return this.$store.state.visaLetterModal.currentStep
  }

  get steps() {
    return VisaLetterModalSteps
  }

  get recipientPassengers(): Passenger[] {
    return this.passengers.filter(
      (passenger) =>
        this.recipients[passenger.id] && this.recipients[passenger.id].isChosen,
    )
  }

  get visaLetterIsReady(): boolean {
    return !!this.visaLetterData
  }

  download(visaLetterPrintable: HTMLElement) {
    const passengerNames = this.recipientPassengers
      .map((p) => p.fullName)
      .join(', ')
    const fileName = `${this.booking.id} - Visa Letter for ${passengerNames}`

    const options = {
      format: 'A4',
      orientation: 'portrait',
      fitToPage: false,
      margin: [1.5, 2.2, 1, 2.2],

      jsPDF: { unit: 'cm' },
      html2canvas: {
        scrollY: 0,
      },
    }
    html2pdf().set(options).from(visaLetterPrintable).save(fileName)
  }

  handleRecipientChoice(recipientId: number) {
    const isChosen = !(
      this.recipients[recipientId] && this.recipients[recipientId].isChosen
    )

    this.$store.commit(VisaLetterModalMutationTypes.SetRecipientIsChosen, {
      recipientId,
      isChosen,
    })
  }

  setStepLetter() {
    if (this.visaLetterIsReady && this.recipientPassengers.length) {
      this.setStep(this.steps.Letter)
    }
  }

  setStep(step: VisaLetterModalSteps): void {
    this.$store.commit(VisaLetterModalMutationTypes.SetStep, step)
  }

  created() {
    this.initialSetup()
  }

  initialSetup() {
    this.autoselectCurrentPassenger()
    this.autoSelectStep()
  }

  autoselectCurrentPassenger() {
    const currentPassenger = this.passengers.find(
      (p) => p.customerId === this.currentCustomer.id,
    )
    if (currentPassenger) {
      this.handleRecipientChoice(currentPassenger.id)
    }
  }

  autoSelectStep() {
    if (this.passengers.length === 1) {
      this.setStep(VisaLetterModalSteps.Letter)
    }
  }
}
